import { render, staticRenderFns } from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=template&id=3f0d2d62&scoped=true"
import script from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=script&lang=js"
export * from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=script&lang=js"
import style0 from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=style&index=0&id=3f0d2d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d2d62",
  null
  
)

export default component.exports